import { computed } from '@vue/composition-api';

/**
 * Default shape for panel intelligence when the digest has none yet.
 * Kept in sync with useDailyDigest initial state and PanelIntelligenceSection props.
 */
const emptyPanelIntelligence = Object.freeze({
  competitors_recently_joined: [],
  suggested_panels: [],
  newly_created_panels: []
});

/**
 * Panel intelligence block from the daily digest API (`panel_intelligence`).
 *
 * @param {Object} params - Configuration
 * @param {import('@vue/composition-api').Ref<Object>} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {import('@vue/composition-api').Ref<boolean>} params.loading - loading ref from useDailyDigest
 * @returns {Object} Reactive panel intelligence for the dashboard section
 */
export function usePanelIntelligence({ dailyDigest, loading }) {
  /**
   * Raw `panel_intelligence` object from the digest ref (same reference as in dailyDigest).
   * Falls back to a stable empty object when missing so the UI never reads a stale copy.
   */
  const panelIntelligence = computed(() => {
    const pi = dailyDigest.value?.panel_intelligence;
    if (!pi || typeof pi !== 'object') {
      return emptyPanelIntelligence;
    }
    return pi;
  });

  const loadingPanelIntelligence = loading;

  return {
    panelIntelligence,
    loading: loadingPanelIntelligence
  };
}
